import { FileHISStateful, FileState } from "core/types";
import { GeneralTableTitle } from "ds_legacy/components/Tables/GeneralTable/TableTitle";
import { GREY_600 } from "ds_legacy/materials/colors";
import { HorizontalLayout } from "ds_legacy/materials/layouts";
import { margin, space } from "ds_legacy/materials/metrics";
import { Body, FONT_SIZE_12 } from "ds_legacy/materials/typography";
import { ClipboardListIcon, LockIcon } from "lucide-react";
import React, { CSSProperties } from "react";
import { useTranslations } from "translations";

export * from "./ReceivedFiles";
export * from "./SentFiles";

export function isFileHISStateful(
  file: FileState | undefined,
): file is FileHISStateful {
  return !!(file as FileHISStateful)?.document_id;
}

export function FilesTableTitle({
  description,
  isMessenger,
  numberOfFiles,
  title,
}: {
  description: string | React.JSX.Element;
  isMessenger?: boolean;
  numberOfFiles: number;
  title: string;
}) {
  return (
    <GeneralTableTitle
      count={numberOfFiles}
      description={description}
      iconProps={{ Icon: ClipboardListIcon }}
      title={title}
      variant={isMessenger ? "minimal" : "default"}
    />
  );
}

const containerStyle = {
  gap: space(0.5),
  margin: margin(1, 0),
};

type EncryptedFileMessageProps = {
  /** Style overrides applied to the icon only */
  iconStyle?: CSSProperties;
  /** Size applied to both icon and text */
  size?: CSSProperties["fontSize"];
  /** Style overrides applied to the element (the container of the icon and text) */
  style?: CSSProperties;
  /** Style overrides applied to the text only */
  textStyle?: CSSProperties;
};

export function EncryptedFileMessage({
  iconStyle,
  size,
  style,
  textStyle,
}: EncryptedFileMessageProps) {
  const translations = useTranslations();

  const contentStyle: CSSProperties = {
    color: GREY_600,
    fontSize: size ?? FONT_SIZE_12,
    lineHeight: size ?? FONT_SIZE_12,
    margin: 0,
  };

  return (
    <HorizontalLayout aligned style={{ ...containerStyle, ...style }}>
      <LockIcon
        size={contentStyle.fontSize}
        style={{ ...contentStyle, ...iconStyle }}
      />
      <Body as="p" style={{ ...contentStyle, ...textStyle }}>
        {translations.fileSection.explanationIcon}
      </Body>
    </HorizontalLayout>
  );
}
